import { escapeHtml } from "@emkit/builder-core";
export const BADGE_DEFAULTS = {
    text: "New",
    variant: "solid",
    shape: "pill",
    size: "md",
    color: "#111827",
    textColor: "#ffffff",
};
const SIZE_PX = {
    sm: { paddingY: 2, paddingX: 8, font: 11 },
    md: { paddingY: 4, paddingX: 10, font: 12 },
    lg: { paddingY: 6, paddingX: 14, font: 14 },
};
function hexToRgba(hex, alpha) {
    const m = hex.replace("#", "").match(/^([0-9a-f]{6}|[0-9a-f]{3})$/i);
    if (!m)
        return hex;
    let h = m[0];
    if (!h)
        return hex;
    if (h.length === 3)
        h = h
            .split("")
            .map((c) => c + c)
            .join("");
    const n = Number.parseInt(h, 16);
    const r = (n >> 16) & 255;
    const g = (n >> 8) & 255;
    const b = n & 255;
    return `rgba(${r},${g},${b},${alpha})`;
}
export const badgeWidget = {
    type: "badge",
    defaultProps: BADGE_DEFAULTS,
    renderHtml(props) {
        const variant = props.variant ?? "solid";
        const shape = props.shape ?? "pill";
        const size = SIZE_PX[props.size ?? "md"];
        const color = props.color ?? "#111827";
        const textColor = props.textColor ?? "#ffffff";
        const radius = shape === "pill" ? 999 : 4;
        let colours;
        if (variant === "solid") {
            colours = `background:${color};color:${textColor};border:1px solid ${color}`;
        }
        else if (variant === "outline") {
            colours = `background:transparent;color:${color};border:1px solid ${color}`;
        }
        else {
            colours = `background:${hexToRgba(color, 0.12)};color:${color};border:1px solid transparent`;
        }
        return `<span class="emk-badge" style="display:inline-flex;align-items:center;padding:${size.paddingY}px ${size.paddingX}px;border-radius:${radius}px;font-size:${size.font}px;font-weight:500;font-family:inherit;line-height:1.3;letter-spacing:0.02em;${colours}">${escapeHtml(props.text)}</span>`;
    },
};
//# sourceMappingURL=badge.js.map